// Essencial Vuex
import Vue from 'vue'
import Vuex from 'vuex'
// Core
import state from './state'
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
// Modulos
import * as firebase from 'firebase'
// Inicia o Vuex
Vue.use(Vuex)
// Store
export default new Vuex.Store({
  state,
  actions,
  getters,
  modules,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/index.js